import { html, nothing } from '@shared/utils/rendering/html';
import { useState, useEffect } from 'preact/hooks';
import { FilterComponents } from '../helpers/filter-components';
import ComponentSection from './component-section';
import NoTableResults from '@shared/components/tables/table-components/no-table-results';

const Attestations = ({ isSuccess, components, filters, dataFilters, filterRef }) => {
    const [filteredComponents, setFilteredComponents] = useState([]);

    useEffect(() => {
        if (!Array.isArray(components)) {
            setFilteredComponents([]);
            return;
        }

        const filtered = FilterComponents({ components, dataFilters });
        setFilteredComponents(filtered);
    }, [components, dataFilters]);

    const hasResults =
        isSuccess && Array.isArray(filteredComponents) && filteredComponents.length > 0;
    const shouldShowNoResults =
        isSuccess &&
        Array.isArray(components) &&
        components.length > 0 &&
        (!filteredComponents || filteredComponents.length === 0);

    return html`
        ${
            hasResults
                ? filteredComponents.map(
                      (item) =>
                          html`<${ComponentSection}
                              details=${item}
                              key=${item.id}
                              filterRef=${filterRef}
                              filters=${filters}
                          />`
                  )
                : nothing
        }
        ${
            shouldShowNoResults
                ? html`<${NoTableResults}
                      message=${{ text: 'No results matching your search.' }}
                  />`
                : nothing
        }
    `;
};

export default Attestations;
